import { Box, FormControl, Grid, Typography } from "@mui/material";
import styles from "../reportSection.module.scss";
import {
  CommonButton,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  CustomMenuItem,
  CustomRequiredInputLabel,
  StyledDateContainer,
  CustomSelectforFamily,
  CommonOutlinedButton,
} from "../../common/StyledComponents/StyledFields";
import { useState, useEffect } from "react";
import { ValidationError, object, string } from "yup";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { apiRequest } from "../../../infrastructure/backendService";
import { PriestListProps } from "../../../infrastructure/GlobalContextProvider";
import apiPath from "../../../config/apiPaths.json";
import { ClipLoader } from "react-spinners";
import CustomSelectField from "../../CompactCustomComponents/CustomSelectField";
import CustomDatePickerField from "../../CompactCustomComponents/CustomDatePickerField";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";

const InventoryReport = ({ sendDataToParent, getReportData }: any) => {

  const formFieldsPriestsBookingReport = {
    dateFrom: dayjs().subtract(7, 'day').format("MM/DD/YYYY"),
    dateTo: dayjs().format("MM/DD/YYYY"),
    category: "",
  };

  const [formData, setFormData] = useState(formFieldsPriestsBookingReport);
  const [loading, setLoading] = useState<boolean>(false);
  const [events, setEvents] = useState<any>([{}]);

  // useEffect(() => {
  //   apiRequest({
  //     method: "GET",
  //     endpoint: apiPath.priestList,
  //     includeToken: true,
  //   })
  //     .then((res) => {
  //       setPriestList(res.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  const getInventoryReports = () => {
    const reqBody = {
      priestName: formData.category,
      poojaFromDate: formData.dateFrom,
      poojaToDate: formData.dateTo,
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint:
        "",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        sendDataToParent(true, reqBody, formData);
        const response = res?.data?.map((obj: any) => {
          return {
            "Priest Name": obj.priestFullName,
            Date: obj.poojadate,
            "Start Time": obj.starttime,
            "End Time": obj.endtime,
            Pooja: obj.poojaname,
            "Type of Pooja": obj.incomeaccount,
            "Booked By": obj.priestSelectedbyFullName,
            "Devotee Name": obj.devoteeFullName,
            "Language preferred of Devotee": obj.preflanguage,
          };
        });
        getReportData(response);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handlSubmit = async () => {
    try {
      getInventoryReports();
    } catch (err) {
      console.log(err)
    }
  };

  const handleFieldChange = (field: any, value: any) => {
    setFormData({
        ...formData,
        [field]: value,
      });
    }

   const handleClear = () => {
    setFormData(formFieldsPriestsBookingReport);
  };

  const DatePickerFrom = (): React.ReactElement => {
    return (
      <CustomDatePickerField
        date={formData.dateFrom}
        handleDateChange={handleFieldChange}
        errorMessage={undefined}
        name="dateFrom"
        format="MM-DD-YYYY"
        disableFuture     
      />
    );
  };

  const DatePickerTo = (): React.ReactElement => {
    return (
      <CustomDatePickerField
        date={formData.dateTo}
        handleDateChange={handleFieldChange}
        errorMessage={undefined}
        name="dateTo"
        format="MM-DD-YYYY"
        disableFuture
      />
    );
  };

  const CategoryDropDown = (): React.ReactElement => {
    return (
      <CustomSelectField
        id="category"
        handleDropdownChange={handleFieldChange}
        errorMessage={""}
        dropDownList={events}
        value={formData.category}
        fieldName="category"
        placeholder={""}
        optionLabel="name"
        optionValue="id"
        overrideStyles={{ backgroundColor: "white" }}
      />
    );
  };

  return (
    <Box  sx={{maxWidth:"450px"}}>
      <Grid container  sx={{ mt: 0 }}  rowSpacing={"10px"}>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Category", false)}
          {CategoryDropDown()}
        </Grid>
      </Grid>
      <Grid container  sx={{ mt: 0 }} columnSpacing={"12px"} rowSpacing={"10px"}>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("From", false)}
          {DatePickerFrom()}
        </Grid>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("To", false)}
          {DatePickerTo()}
        </Grid>
      </Grid>
      <Grid sx={{ mt: 3, display: "flex", gap: "16px" }}  columnSpacing={"12px"} rowSpacing={"10px"}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmit}
          disabled={loading}
          id="submit"
        >
          <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
        </CommonButton>
        <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
      </Grid>
    </Box>
  );
};

export default InventoryReport;
